<template>
  <div class="user-info" :class="{ 'is-vertical': vertical }">
    <div v-if="tooltip" v-tooltip="tooltip">
      <user-avatar :user="user" :size="size" v-bind="$attrs"></user-avatar>
    </div>
    <user-avatar v-else :user="user" :size="size" v-bind="$attrs"></user-avatar>
    <div class="user-info__details">
      <span class="user-info__name">{{ user.name }}</span>
      <span v-if="showEmail" class="user-info__email">{{ user.email }}</span>
    </div>
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";

export default {
  name: "UserInfo",
  components: { UserAvatar },
  inheritAttrs: false, 
  props: {
    user: {
      type: Object,
      required: true
    },
    showEmail: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 35
    },
    vertical: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.user-info {
  display: flex;
  align-items: center;
  gap: 5px;

  &.is-vertical {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__details {
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-size: 14px;
    color: var(--ld-text-primary);
    line-height: 1.2;
  }

  &__email {
    font-size: 12px;
    color: var(--ld-text-tertiary);
  }
}
</style> 